export default __webpack_public_path__ + "delivery-checkba0894.png";